<template>
    <BreadCrumb PageTitle="Ajouter une Organisation" />
    <AddOrganisation />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue"
    import AddOrganisation from "@/components/Organisation/AjouterOrganisation.vue";
  
    export default defineComponent({
      name: "AddOrganisationPage",
      components: {
        BreadCrumb,
        AddOrganisation
      },
    });
  </script>